/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function changeText() {
// 	document.querySelector(".dice_book-now").innerHTML = "hi";
// }

// window.onload = function () {
// 	changeText();
// };

// function changeText() {
// 	document.querySelector(".dice_book-now").innerHTML = "hi";
// }

// $(document).ready(function () {
// 	changeText();
// });

// AOS
AOS.init();

// textwith image

$(".imageCarousel").slick({
	dots: true,
	infinite: true,
	arrows: false,
	slidesToShow: 1,
	slideToScroll: 1,
	fade: true,
	autoplay: true,
	autoplaySpeed: 4000,
});

// brochure
$(".slickCarousel").slick({
	dots: false,
	infinite: true,
	arrows: false,
	slidesToShow: 1,
	slideToScroll: 1,
	fade: true,
	autoplay: true,
	autoplaySpeed: 5000,
});

// AOS.init({
// 	duration: 1000,
// 	once: true,
// });

// Gallery Load More Button

$(document).ready(function () {
	if ($(".image-figure").length <= 11) {
		$(".load-more").hide();
	}
	$(".image-figure").slice(0, 11).show();
	$(".load-more").on("click", function (e) {
		e.preventDefault();
		$(".image-figure:hidden").slice(0, 4).slideDown();
		if ($(".content:hidden").length == 0) {
			$(".load-more").fadeOut("slow");
		}
	});
});

// $(".dice_events").addClass("buttonsss");

// onscroll class
$(window).scroll(function () {
	var sticky = $(".Header__Wrapper"),
		scroll = $(window).scrollTop();
	if (scroll > 50) sticky.addClass("fixed");
	else sticky.removeClass("fixed");
});

// Toggle Menu
$(".Header__Icon").click(function () {
	$(".SidebarMenu").animate({ width: "toggle" });
	$(".Header__Icon").toggleClass("change");
	$(".Drawer__Main").toggleClass("active");
	$(".Drawer__Footer").toggleClass("active");
});

// Contact Button Tab
$(".contact-btn-wrapper a").click(function () {
	// Check for active
	$(this).parent().addClass("active");

	// Display active tab
	let currentTab = $(this).attr("href");
	$(".tabs-content .toggle-content").hide();
	$(currentTab).show();

	return false;
});

// close tab button
$(".close").on("click", function () {
	$(this).closest(".toggle-content").hide();
	$(".top-content").slideDown();
	$(".bot-content").removeClass("active");
});

// Slideup
$(".toggle-btn-content").click(function () {
	$(".top-content").slideUp();
	$(".bot-content").addClass("active");
});

// Remove href
$(".Footer .FAQ").removeAttr("href");
$(".first-footer-menu.class-2").removeAttr("href");
$(".mobile-menu.class-3").removeAttr("href");
$(".mobile-menu.class-4").removeAttr("href");

// Slideup content 1
$(".FAQ, .mobile-menu.class-4").click(function () {
	$(".faq-content").show();
	$("html, body").animate({ scrollTop: 0 }, 700);
	$("main").slideUp();
	$(".faq-content").addClass("active");
});

$(".faq-content .close").on("click", function () {
	$(this).closest(".faq-content").hide();
	$("main").slideDown();
	$(".faq-content").removeClass("active");
});

// Slideup content 2
$(".mobile-menu.class-3, .first-footer-menu.class-2").click(function () {
	$(".transport-content").show();
	$("html, body").animate({ scrollTop: 0 }, 700);
	$("main").slideUp();
	$(".transport-content").addClass("active");
});

$(".transport-content .close").on("click", function () {
	$(this).closest(".transport-content").hide();
	$("main").slideDown();
	$(".transport-content").removeClass("active");
});
